import React, { useEffect, useState } from 'react';
import { Row, Col, Container, Card, Button } from 'react-bootstrap';
import styles from './index.css';
import location from './image/location.svg';
import vector from './image/calendar.svg';
import thumpup from './image/thumbsup.png';
import twitter from './social/twitter.png';
import { compose } from 'recompose';
import { useDispatch, useSelector } from 'react-redux';
import propTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import moment from 'moment-timezone';
import 'moment-timezone';
import SvgFooterLandscape from '../../../../components/svgs/svgFooterLandscape';
import RegisterEventForm from '../../registerEventForm';
import { ThemeProvider } from 'styled-components';
import { themeViaForms } from '../../../../../styledComponents/settings/theme';
import { fetchVisitorEvent } from '../../../../../actions/visitorEventsActions';
import { defaultEventImage } from '../../../../../shared/helpers/event';
import { inviteSingleTraveler } from '../../../../../actions/visitorEventsActions';
import EventErrorScreen from '../../../../forms/pages/EventErrorScreen';
import { CircularProgress } from '@material-ui/core';
import Facebook from '../../../../programs/components/header/share/Facebook';
import WhatsApp from '../../../../programs/components/header/share/WhatsApp';
import CopyLink from '../../../../programs/components/header/share/CopyLink';
import useMediaQuery from '../../../../../hooks/useMediaQuery';
import EventMobileView from './EventMobileView';
import { stripHtml } from '../../../../../helpers/CommonHelper';

export const enhance = compose(withStyles(styles));

function EventRegistration(props) {
  const dispatch = useDispatch();
  const { isMobile } = useMediaQuery();
  const { innerWidth: width } = window;
  const orgDetailsPublic = useSelector(state => state.orgSettings.orgDetailsPublic);
  const inviteTraveler = useSelector(state => state.visitorEvents.inviteSingleTraveler);
  const visitorEvent = useSelector(state => state.visitorEvents.event);
  const visitorEventDetail = useSelector(state => state.visitorEvents);
  const [event, setEvent] = useState();
  const [showRegistration, setShowRegistration] = useState(true);
  const [submitted, setSubmitted] = useState(false);
  const [eventDesc, setEventDesc] = useState('');
  const [showMore, setShowMore] = useState(false);
  const DESCRIPTION_CHARS = innerWidth >= 768 ? 350 : 230;
  const [registrationUrl, setRegistrationUrl] = useState('');
  const [showFullDescription, setShowFullDescription] = useState(false);
  const [eventDefaultImage, setEventDefaultImage] = useState(null);
  const [shareLink, setShareLink] = useState({
    twitter: '',
  });

  useEffect(() => {
    setEventDefaultImage(defaultEventImage());
  }, []);

  useEffect(() => {
    if (visitorEvent?.id) {
      generateShareLink(visitorEvent?.name);
    }
  }, [visitorEvent?.id]);

  const toggleDescription = () => {
    setShowFullDescription(prev => !prev);
  };

  useEffect(() => {
    if (!!props.eventId) {
      setRegistrationUrl(window.location.href);
      dispatch(fetchVisitorEvent(props.eventId));
    }
  }, [props]);

  useEffect(() => {
    if (inviteTraveler && inviteTraveler.status === 'ok') {
      setShowRegistration(false);
      setSubmitted(true);
    }
  }, [inviteTraveler]);

  useEffect(() => {
    let description = '';
    if (!!visitorEvent) {
      let backgroundImage = '';
      if (visitorEvent.background_photo) {
        backgroundImage = visitorEvent.background_photo
          .toString()
          .toLowerCase()
          .startsWith('http')
          ? visitorEvent.background_photo
          : eventDefaultImage;
      }

      description = visitorEvent?.description?.replace(/<p><\/p>/g, '<br />');
      setEventDesc(description);

      const buildEvent = {
        id: visitorEvent.id,
        title: visitorEvent.name || '',
        start: moment(visitorEvent.start).isValid()
          ? moment.tz(visitorEvent.start, visitorEvent.timezone).format('MMM D, YYYY, h:mma z')
          : 'No Start Date',
        end: moment(visitorEvent.ending).isValid()
          ? moment.tz(visitorEvent.ending, visitorEvent.timezone).format('MMM D, YYYY, h:mma z')
          : null,
        location: visitorEvent.location,
        description: description,
        descriptionWithHtml: visitorEvent.description || '',
        backgroundPhoto: backgroundImage,
        deleted: visitorEvent.deleted,
        defaultPhoto: `${window.location.host}${eventDefaultImage}`,
      };

      setEvent(buildEvent);
    }
  }, [visitorEvent]);

  const onSubmit = user => {
    dispatch(
      inviteSingleTraveler(event.id, {
        first_name: user.firstname,
        last_name: user.lastname,
        email: user.email,
      }),
    );
  };

  const generateShareLink = eventName => {
    const message = eventName;
    const encodedMessage = encodeURIComponent(message);
    const encodedUrl = encodeURIComponent(window.location.href);

    const twitterLink = `https://twitter.com/intent/tweet?text=${encodedMessage}&url=${encodedUrl}`;

    setShareLink({
      twitter: twitterLink,
    });
  };

  const renderDescription = () => {
    let words = stripHtml(event.description);
    // words = words.split(' ');

    if (words.length <= 200 || showFullDescription) {
      return event?.description;
    }
    return `${event?.description?.slice(0, 200)}<span>...</span>`;
    // return `${event?.description.split(' ').slice(0, 50).join(' ')}...`;
  };

  function handleShareLinkClick(shareUrl) {
    if (!shareUrl) {
      shareUrl = window.location.href;
    }

    const width = 550;
    const height = 400;
    const left = window.outerWidth / 2 + (window.screenX || window.screenLeft || 0) - width / 2;
    const top = window.outerHeight / 2 + (window.screenY || window.screenTop || 0) - height / 2;

    const config = {
      height: height,
      width: width,
      left: left,
      top: top,
      location: 'no',
      toolbar: 'no',
      status: 'no',
      directories: 'no',
      menubar: 'no',
      scrollbars: 'yes',
      resizable: 'no',
      centerscreen: 'yes',
      chrome: 'yes',
    };

    window.open(
      shareUrl,
      '',
      Object.keys(config)
        .map(key => key + '=' + config[key])
        .join(', '),
    );
  }

  if (visitorEventDetail?.loading) {
    return (
      <div
        className={`${styles.gap_div} d-flex align-items-start d-flex  align-items-center gap-1 justify-content-center vh-100`}
      >
        <div className="mb-2" style={{ fontSize: '1rem' }}>
          Loading...
        </div>
        <CircularProgress color="inherit" size={32} />
      </div>
    );
  }

  if (event?.id) {
    return (
      <>
        {isMobile ? (
          <EventMobileView
            event={event}
            orgLogo={orgDetailsPublic.logo}
            eventDefaultImage={eventDefaultImage}
            handleShareLinkClick={handleShareLinkClick}
            shareLink={shareLink}
          />
        ) : (
          <Container
            fluid
            className={`d-flex flex-column m-0 p-0 pt-2 justify-content-between align-items-center ${styles.signup_container}`}
          >
            <Row className="pt-2 m-0">
              <Col>
                <Card className={`${styles.signup_card}`}>
                  <div className={`${styles.groupimage_height}`}>
                    <Card.Img
                      variant="top"
                      src={event?.backgroundPhoto ? event.backgroundPhoto : eventDefaultImage}
                      className={`img-fluid ${styles.group_img}`}
                      alt="Background image for the event"
                    />
                  </div>
                  <div className={`${styles.img_group} text-center`}>
                    <Card.Img
                      variant="top"
                      src={orgDetailsPublic.logo}
                      className={`img-fluid ${styles.centered_image}`}
                      alt="Event host image for the logo"
                    />
                  </div>
                  <Card.Body className={` d-flex flex-column gap-lg-3 gap-md-3 gap-sm-1 p-lg-5 p-md-5 px-sm-3`}>
                    {!!event && !!event.id ? (
                      <>
                        <header>
                          <div className="d-flex justify-content-between align-items-center">
                            {!showRegistration && !submitted && (
                              <>
                                <button
                                  className={styles.goBackBtn}
                                  type="button"
                                  onClick={() => setShowRegistration(true)}
                                >
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="13"
                                    height="13"
                                    viewBox="0 0 13 13"
                                    fill="none"
                                  >
                                    <path
                                      fill-rule="evenodd"
                                      clip-rule="evenodd"
                                      d="M8.6249 2.62606C8.85647 2.85763 8.85647 3.23308 8.6249 3.46465L5.48637 6.60318L8.6249 9.74171C8.85647 9.97328 8.85647 10.3487 8.6249 10.5803C8.39333 10.8119 8.01788 10.8119 7.78631 10.5803L4.22849 7.02247C3.99692 6.7909 3.99692 6.41546 4.22849 6.18389L7.78631 2.62606C8.01788 2.39449 8.39333 2.39449 8.6249 2.62606Z"
                                      fill="#373737"
                                    />
                                  </svg>
                                  Go Back
                                </button>
                              </>
                            )}
                          </div>
                        </header>
                        <main>
                          <Row>
                            <Col xs={12} className="text-center">
                              <h2 className={`${styles.heading} m-0 mb-2`}>ADVANCE SIGN-UP</h2>
                              <h1 className={`${styles.heading_two}`}>{event.title}</h1>
                            </Col>
                          </Row>
                          {showRegistration && !submitted && (
                            <>
                              <Row>
                                <Col lg={6} md={6} sm={6}>
                                  <div className={`${styles.location_main}`}>
                                    <h4>Location</h4>
                                    <div className={`${styles.gap_div} d-flex align-items-start `}>
                                      <div>
                                        <Card.Img
                                          variant="top"
                                          src={location}
                                          style={{ height: '25px', minWidth: '25px' }}
                                          className={`img-fluid`}
                                        />
                                      </div>

                                      <div className={`${styles.location_content}`}>
                                        <p>
                                          {event.location} <br />
                                          <span>{event.locationDetails}</span>
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </Col>
                                <Col lg={6} md={6} sm={6}>
                                  <div className={`${styles.Date_main}`}>
                                    <h4>Date</h4>
                                    <div className={`${styles.gap_div} d-flex align-items-start `}>
                                      <div>
                                        <Card.Img
                                          variant="top"
                                          src={vector}
                                          style={{ height: '28px' }}
                                          className={`img-fluid`}
                                        />
                                      </div>

                                      <div className={`${styles.date_content}`}>
                                        <p>
                                          {event.start} <br />
                                          {!!event.end && (
                                            <>
                                              <span className="fw-normal">to</span> {event.end}
                                            </>
                                          )}
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </Col>
                              </Row>
                              {!event.deleted ? (
                                <div className={`${styles.Description}`}>
                                  <h4>Event Description</h4>
                                  <div className={`${styles.description_paragraph}`}>
                                    <div
                                      dangerouslySetInnerHTML={{
                                        __html: renderDescription(),
                                      }}
                                    />

                                    {stripHtml(event.description)?.length > 200 && (
                                      <span className={`${styles.more_detail}`} onClick={toggleDescription}>
                                        {showFullDescription ? ' show less' : ' more details'}
                                      </span>
                                    )}

                                    {/* </div> */}
                                  </div>
                                  <div className={`${styles.RegisterBtnMain}`}>
                                    <Button
                                      className={`${styles.Register_Btn}`}
                                      onClick={() => setShowRegistration(false)}
                                    >
                                      Sign-Up
                                    </Button>
                                  </div>
                                </div>
                              ) : (
                                <div className={`${styles.cancelled}`}>Event has been cancelled</div>
                              )}
                            </>
                          )}
                          {!showRegistration && !submitted && (
                            <div className={`${styles.registrationForm}`}>
                              <RegisterEventForm eventId={event.id.toString()} onSubmit={onSubmit} />
                            </div>
                          )}
                          {submitted && (
                            <div className="success">
                              <div className="messageWrapper">
                                <div className="text-center my-3">
                                  <img alt="Copy Link" src={thumpup} className="icon" />
                                </div>

                                <div className={`${styles.spacing} text-center mt-3`}>
                                  <p className={`${styles.para} m-0 fw-bold `}>You’re registered for this event.</p>
                                  <p className={`${styles.para} m-0`}>We’ve sent you an email with event details.</p>
                                </div>
                              </div>
                              <div className="text-center mt-3">
                                <div className="d-flex align-items-center justify-content-center">
                                  <div>
                                    <p
                                      className={`${styles.sharing_social_div} m-0 me-2 `}
                                      style={{ fontSize: '14px' }}
                                    >
                                      Share Event :{' '}
                                    </p>
                                  </div>
                                  <div className="d-flex gap-3 align-items-center justify-content-center ">
                                    <Facebook
                                      url={window.location.href}
                                      hashtag="#ViaTRM"
                                      clickHandler={handleShareLinkClick}
                                    />
                                    <a
                                      href={'#'}
                                      onClick={e => {
                                        e.preventDefault();
                                        handleShareLinkClick(shareLink.twitter);
                                      }}
                                      style={{ marginLeft: '8px', marginRight: '8px' }}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      <Card.Img
                                        variant="top"
                                        src={twitter}
                                        className={`${styles.social} img-fluid ms-3`}
                                      />
                                    </a>

                                    <WhatsApp
                                      url={window.location.href}
                                      title={visitorEvent?.name}
                                      clickHandler={handleShareLinkClick}
                                    />
                                    <CopyLink url={window.location.href} position="bottom" />
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}
                        </main>
                      </>
                    ) : (
                      <></>
                    )}
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </Container>
        )}

        <div className={`${styles.footer} w-100`} style={{ height: '200px' }}>
          <SvgFooterLandscape color={orgDetailsPublic.accentColor} />
        </div>
      </>
    );
  }

  if (!event?.id && !visitorEventDetail?.loading) {
    return (
      <div>
        <div style={{ minHeight: '80vh' }}>
          <ThemeProvider theme={themeViaForms}>
            <EventErrorScreen />
          </ThemeProvider>
        </div>
        <div className={`w-100`} style={{ height: '200px', position: 'fixed', bottom: '0' }}>
          <SvgFooterLandscape color={orgDetailsPublic.accentColor} />
        </div>
      </div>
    );
  }
}

EventRegistration.propTypes = {
  eventId: propTypes.string.isRequired,
};

export default enhance(EventRegistration);
